var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex-column" },
    [
      _c(
        "div",
        { staticClass: "mb-2" },
        [
          _c(
            "ib-button-basic",
            { attrs: { color: "blue", to: { name: "payment" }, filled: "" } },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.subscriptionIsFreeTrial || !_vm.isSubscribed
                      ? _vm.$t("pages.billing.upgrade")
                      : _vm.$t("pages.billing.updateSubscription")
                  ) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
      !_vm.subscriptionIsFreeTrial &&
      _vm.isSubscribed &&
      !_vm.isCurrentSubscriptionDeleted
        ? [
            _c(
              "ib-button-basic",
              {
                staticClass: "w-100",
                attrs: { color: "gray" },
                on: {
                  click: function ($event) {
                    _vm.dialogCancelAccountVisible = true
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("pages.billing.cancelSubscription")) + " "
                ),
              ]
            ),
          ]
        : _vm._e(),
      _c("dialog-cancel-account", {
        attrs: { visible: _vm.dialogCancelAccountVisible },
        on: {
          close: function ($event) {
            _vm.dialogCancelAccountVisible = false
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }